import React from "react";
import { Dimmer, Loader, Icon, IconGroup, Segment } from "semantic-ui-react";

const LoaderExampleLoader = (prop) => (
   
        <Dimmer  active className="myloading">
            {prop.errcon ? (
                <>
                    <IconGroup size="huge" style={{ marginTop: "10%" }}>
                        <Icon color="grey" name="internet explorer" inverted />
                        <Icon size="big" color="red" name="dont" />
                    </IconGroup>
                    <br />
                    <br />
                    <br />
                    <br />
                    Connection Error!
                </>
            ) : (
                <Loader size="huge" />
            )}
        </Dimmer>
 
);

export default LoaderExampleLoader;
